import gql from 'graphql-tag'

// shouldn't do it this way but :shrug:
import { postListVars } from 'libreon/Discuss/graphqlVars'
import { projectListValues } from 'libreon/Project/graphql'

const publicUserData = 'data(types: ["profile", "social"]) { id type value }'
const emailListVars = 'id address primary verified status'
const emailLoadVars = `${emailListVars} issues { id type issue insertedAt }`
const phoneListVars = 'id number primary verified'
const userListTagVars = 'id type public meta tag { id label meta }'
const userAllTags = `tags { ${userListTagVars} }`
const userServiceTags = `tags(types: ["service"]) { ${userListTagVars} }`

// projectListValues is a bit more than the list values below
const publicUserListProj = 'projects { id type project {id shortId title format}}'
const publicUserLoadProj = `projects { id type project { ${projectListValues} } }`

// / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / / /
export const userListVars =
  'id handle name avatar house verified lastSeen updatedAt insertedAt'

const userLoadVars = `
  ${userListVars}
  ${userAllTags}
  emails { ${emailLoadVars} }
  phones { ${phoneListVars} }
  tallys { id type total }
  settings
  access { roles actions }
  authStatus
  data { id type value }
  messages(action: SUMMARY) { success, meta }
`

////////////////////////////////////////////////////////////////////////////////
export const LOAD_USER = gql`
  query loadUser($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result { ${userLoadVars} }
    }
  }
`

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ShortId, $action: ChangeActions,
    $user: InputUser, $handle: InputHandle, $email: InputEmail,
    $phone: InputPhone, $data: InputMixedData, $role: InputRole)
  {
    updateUser(
      id: $id, action: $action,
      user: $user, handle: $handle, email: $email,
      phone: $phone, data: $data, role: $role)
    {
      success
      reason
      result {
        ${userLoadVars}
      }
    }
  }
`

////////////////////////////////////////////////////////////////////////////////
const mailerSubVars = 'id originId userId class allow updatedAt'

export const MAILER_SUBS = gql`
  query mailerSubs($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result { id mailerSubs { ${mailerSubVars} } }
    }
  }
`

export const SET_MAILER_SUB = gql`
  mutation upsertMailerSub($userId: UUID!, $originId: UUID!, $class: MailerSubClass!, $allow: Boolean!) {
    upsertMailerSub(userId: $userId, originId: $originId, class: $class, allow: $allow) {
      ${mailerSubVars}
    }
  }
`

// id is defined, but only works with self
export const LOAD_USER_MESSAGES = gql`
  query loadUserDiscuss($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        messages {
          success
          results { ...on DiscussPost {
            ${postListVars}
            type recipient { id handle avatar name }
          }}
        }
      }
    }
  }
`

////////////////////////////////////////////////////////////////////////////////
export const PUBLIC_USER_LIST = gql`
  query connectFindList($filter: [FilterColumn]) {
    connectFind(filter: $filter) {
      status { success matching total }
      results { ${userListVars} ${userServiceTags} ${publicUserListProj} }
    }
  }
`

export const PUBLIC_USER_LOAD = gql`
  query connectFindLoad($id: ShortId!) {
    connectFind(id: $id) {
      status { success matching total }
      result {
        ${userListVars} ${userServiceTags} ${publicUserData} ${publicUserLoadProj}
      }
    }
  }
`

////////////////////////////////////////////////////////////////////////////////
export const GEN_APIKEY = gql`
  mutation genApiKey {
    genApiKey {
      access
    }
  }
`

export const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String, $id: ShortId) {
    requestPasswordReset(email: $email, id: $id) {
      success
      reason
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword($current: String, $new: String!, $code: String) {
    changePassword(current: $current, new: $new, code: $code) {
      success
      reason
    }
  }
`

export const MY_FACTORS = gql`
  query myFactors($type: String, $id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        factors(type: $type) {
          id
          type
          expiresAt
        }
      }
    }
  }
`

export const GET_ACCESS = gql`
  query getAccess($type: AccessDomain!, $refId: UUID!) {
    getAccess(type: $type, refId: $refId)
  }
`

export const inviteValues = `
  id
  shortId
  expiresAt
  requestorId
  requestType
  targetType
  requestAccess
  resourceType
  resourceId
  projectId
  orgId
  email
  targetId
  note
  target {
    ${userListVars}
    id
    name
    handle
  }
`

export const INVITE = gql`
  mutation invite(
    $action: InviteAction!
    $targetType: InviteTargetType
    $requestType: InviteRequestType
    $requestAccess: InviteAccessType
    $responseType: InviteResponseType
    $responseAccess: InviteAccessType
    $resourceType: InviteResourceType
    $resourceId: UUID
    $projectId: UUID
    $targetId: UUID
    $orgId: UUID
    $note: String
    $email: String
    $shortId: ShortId
  ) {
    invite(
      action: $action
      targetType: $targetType
      requestType: $requestType
      requestAccess: $requestAccess
      responseType: $responseType
      responseAccess: $responseAccess
      resourceType: $resourceType
      resourceId: $resourceId
      targetId: $targetId
      projectId: $projectId
      orgId: $orgId
      note: $note
      email: $email
      shortId: $shortId
    ) {
      success
      reason
      result {
        id
        shortId
        expiresAt
      }
    }
  }
`

export const DELETE_ACCOUNT = gql`
  mutation deleteAccount($code: String) {
    deleteAccount(code: $code) {
      success
      reason
    }
  }
`
